import {Component} from '@angular/core';

@Component({
    moduleId: module.id,
    templateUrl: 'about.component.html'
})

export class AboutComponent {

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/about/about.component.ts